import { render, staticRenderFns } from "./change-legal-entity-reference-modal.vue?vue&type=template&id=9878b374&"
import script from "./change-legal-entity-reference-modal.ts?vue&type=script&lang=js&"
export * from "./change-legal-entity-reference-modal.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports